import { useInView } from '../../../hooks/useInView';

export default function SummitSystems() {
  const { ref, inView } = useInView();

  const systems = [
    { icon: 'ri-login-box-line', title: 'Intake Elevation', description: 'Streamlined client onboarding and qualification — first impressions engineered.' },
    { icon: 'ri-route-line', title: 'Client Journey Automation', description: 'Intelligent touchpoints across the entire customer lifecycle.' },
    { icon: 'ri-money-dollar-circle-line', title: 'Revenue Optimization Layer', description: 'Data-driven insights that lift conversion and lifetime value.' },
    { icon: 'ri-dashboard-3-line', title: 'Operational Clarity Engine', description: 'Real-time visibility into workflows, bottlenecks, and performance.' },
    { icon: 'ri-star-smile-line', title: 'Reputation Intelligence System', description: 'Automated feedback collection and brand signal monitoring.' },
  ];

  return (
    <section id="systems" className="bg-white py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-8">
        <div
          ref={ref}
          className={`mb-20 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <p className="text-teal-600 text-xs font-semibold tracking-[0.2em] uppercase mb-4">Proprietary Framework</p>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <h2 className="font-serif text-5xl lg:text-6xl font-bold text-slate-900 leading-tight">
              The Summit Systems™<br />Core Intelligence Framework.
            </h2>
            <p className="text-slate-500 text-base leading-relaxed max-w-sm">
              Every engagement is structured through our proprietary architecture — built to integrate without disruption.
            </p>
          </div>
        </div>

        <div className="space-y-px bg-slate-100 rounded-3xl overflow-hidden">
          {systems.map((s, i) => (
            <div
              key={i}
              className={`bg-white flex items-center gap-8 px-10 py-8 hover:bg-slate-50 transition-all duration-500 group cursor-default ${inView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="text-3xl font-serif text-slate-100 group-hover:text-teal-100 transition-colors w-12 shrink-0 text-right select-none">
                {String(i + 1).padStart(2, '0')}
              </div>
              <div className="w-10 h-10 flex items-center justify-center shrink-0">
                <i className={`${s.icon} text-xl text-teal-600`} />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-slate-900 text-base">{s.title}</h3>
                <p className="text-slate-500 text-sm mt-1">{s.description}</p>
              </div>
              <div className="w-6 h-6 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-line text-teal-600" />
              </div>
            </div>
          ))}
        </div>

        <p className={`text-center text-slate-400 text-sm mt-8 italic transition-all duration-700 delay-600 ${inView ? 'opacity-100' : 'opacity-0'}`}>
          Each module integrates seamlessly into your existing operations — elevating performance without disruption.
        </p>
      </div>
    </section>
  );
}
